import React, { useState } from "react";
import { generateToken } from "../api/apiService";
import { toast } from "react-toastify";
import {
  Modal,
  Box,
  Typography,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Chip,
  CircularProgress, // Importa o CircularProgress do MUI
} from "@mui/material";
import styles from "../styles/LinkGeneratorModal.module.css";

const LinkGeneratorModal = ({ isOpen, onClose, solicitacaoId }) => {
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [generatedLink, setGeneratedLink] = useState("");
  const [isLinkGenerated, setIsLinkGenerated] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // Estado para o loading

  const documentOptions = [
    { label: "RG", value: "RG" },
    { label: "CPF", value: "CPF" },
    { label: "SUS", value: "SUS" },
    { label: "Comprovante de Residência", value: "COMPROVANTE_DE_RESIDENCIA" },
    { label: "Receita", value: "RECEITA" },
    { label: "Outros", value: "OUTROS" },
  ];

  const handleGenerateLink = async () => {
    try {
      setIsLoading(true);
      const body = {
        [solicitacaoId]: selectedDocuments,
      };
      const token = await generateToken(body);
      const currentUrl = window.location.origin;
      const link = `${currentUrl}/upload-documents/${token}`;
      setGeneratedLink(link);
      setIsLinkGenerated(true);
    } catch (error) {
      console.error("Erro ao gerar o token:", error);
      toast.error("Erro ao gerar o token. Tente novamente.");
    } finally {
      setIsLoading(false);
    }
  };

  const closeModal = () => {
    setSelectedDocuments([]);
    setGeneratedLink("");
    setIsLinkGenerated(false);
    onClose();
  };

  const handleChange = (event) => {
    setSelectedDocuments(event.target.value);
  };

  return (
    <Modal
      open={isOpen}
      onClose={closeModal}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: "90%",
          maxWidth: 500,
          bgcolor: "background.paper",
          borderRadius: 2,
          p: 4,
          boxShadow: 24,
        }}
        onClick={(e) => e.stopPropagation()} // Impede a propagação do clique
      >
        {!isLinkGenerated ? (
          <>
            <Typography variant="h6" gutterBottom>
              Selecionar Documentos para Gerar Link
            </Typography>
            <FormControl fullWidth>
              <InputLabel id="document-select-label">Documentos</InputLabel>
              <Select
                labelId="document-select-label"
                multiple
                value={selectedDocuments}
                onChange={handleChange}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip key={value} label={value} />
                    ))}
                  </Box>
                )}
              >
                {documentOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mt: 3,
                gap: 2,
              }}
            >
              <Button
                onClick={handleGenerateLink}
                variant="contained"
                color="success"
                disabled={selectedDocuments.length === 0 || isLoading}
                fullWidth
              >
                {isLoading ? (
                  <CircularProgress size={24} style={{ color: "white" }} />
                ) : (
                  "Gerar Link"
                )}
              </Button>
              <Button
                onClick={closeModal}
                variant="outlined"
                color="error"
                fullWidth
              >
                Cancelar
              </Button>
            </Box>
          </>
        ) : (
          <>
            <Typography variant="h6" gutterBottom>
              Link Gerado
            </Typography>
            <Typography>
              Copie o link abaixo para compartilhamento:
            </Typography>
            <input
              type="text"
              value={generatedLink}
              readOnly
              className={styles.generatedLinkInput}
              onClick={(e) => e.target.select()}
              style={{
                width: "100%",
                padding: "8px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                marginTop: "8px",
                marginBottom: "16px",
              }}
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: 2,
              }}
            >
              <Button
                onClick={() => {
                  navigator.clipboard.writeText(generatedLink);
                  toast.success("Link copiado para a área de transferência!");
                }}
                variant="contained"
                color="primary"
                fullWidth
              >
                Copiar Link
              </Button>
              <Button
                onClick={closeModal}
                variant="outlined"
                color="error"
                fullWidth
              >
                Fechar
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default LinkGeneratorModal;
